<template>
  <Modal :config="modal">
    <template v-slot:header>
      <h4 class="title is-4">{{ translations.famoco_assign_fleet }}</h4>
    </template>

    <div v-if="fleets.length === 0" class="notification is-warning is-light">
      {{ translations.famoco_no_fleets_hint }}
    </div>
    <Select v-else :config="selectFleet" v-model="fleetId" />

    <template v-slot:footer>
      <button
        class="button is-success"
        :disabled="fleetId === ''"
        @click="submit()"
      >{{ translations.famoco_assign_fleet }} ({{ selectedDevices.length }})</button>
      <button
        class="button is-warning"
        @click="putInStock()"
      >{{ translations.famoco_put_in_stock }} ({{ selectedDevices.length }})</button>
    </template>
  </Modal>
</template>

<script lang="ts">
import { ISelect } from '@/components/form';
import Select from '@/components/form/select.vue';
import Modal from '@/components/modal.vue';
import { IFamocoFleet } from '@/models/famoco';
import router from '@/router';
import store from '@/store';
import { IBulkDevicesFleet } from '@/store/modules/devices';
import { IFamocoState } from '@/store/modules/famoco';
import { IDevicesTranslations } from '@/translations';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { deviceModal } from '../';

@Component({
  name: 'AssignDevicesFleet',
  components: { Modal, Select }
})
class AssignDevicesFleet extends Vue {
  @Action('setFamocoDevicesFleet') public assignFleet!: (devices: IBulkDevicesFleet) => void;
  @Action('fetchFamocoConfig') public fetchFamocoConfig!: () => void;

  @Getter('getSelectedDevices') public selectedDevices!: number[];
  @Getter('getFamocoState') public famocoState!: IFamocoState;
  @Getter('getDevicesTranslations') public translations!: IDevicesTranslations;

  public fleetId = '';
  public modal = deviceModal;
  public selectFleet: ISelect = { id: 'select-fleet', default: 'Select fleet', value: '', options: [] };

  get fleets(): IFamocoFleet[] {
    return this.famocoState.fleets;
  }

  public created() {
    if (this.famocoState.fleets.length === 0) {
      this.fetchFamocoConfig();
    }

    this.selectFleet = {
      id: 'select-fleet',
      default: 'Select fleet',
      value: '',
      options: this.fleets.map(f => ({ label: f.name, value: String(f.id) }))
    };

    store.watch(
      state => (state as any).famoco.fleets,
      (fleets: IFamocoFleet[]) => {
        this.selectFleet = {
          ...this.selectFleet,
          options: fleets.map(f => ({ label: f.name, value: String(f.id) }))
        };
      }
    );
  }

  public submit() {
    if (this.fleetId === '') { return; }
    this.assignFleet({ ids: this.selectedDevices, fleet_id: Number(this.fleetId) });
    router.push('/devices');
  }

  public putInStock() {
    this.assignFleet({ ids: this.selectedDevices, fleet_id: null });
    router.push('/devices');
  }

  public close() {
    router.push('/devices');
  }
}

export default AssignDevicesFleet;
</script>
